<template>
  <CommonEmployeeDetailsModal title="Manage Leave Type">
    <SchoolLeaveDetailEditForm
      :is-busy="isBusy"
      :form-set="selectedLeave"
      @handle-submit="handleSubmit"
    ></SchoolLeaveDetailEditForm>
  </CommonEmployeeDetailsModal>
</template>

<script>
import CommonEmployeeDetailsModal from "@/modules/school/components/shared/employee/modal/CommonEmployeeDetailsModal";
import SchoolLeaveDetailEditForm from "@/modules/school/components/management/leave/detail/SchoolLeaveDetailEditForm";
export default {
  name: "SchoolLeaveDetailModal",
  components: { SchoolLeaveDetailEditForm, CommonEmployeeDetailsModal },

  props: {
    title: {
      String,
    },
    selectedLeave: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isBusy: false,
    };
  },

  mounted() {
    console.log("Mounted", this.selectedLeave);
  },

  methods: {
    /**
     *
     * @param form
     */
    handleSubmit(form) {
      console.log(form);

      const payload = {
        ...form,
        id: this.selectedLeave.id,
      };

      this.isBusy = true;
      this.$store
        .dispatch("updateSchoolLeaveDetails", payload)
        .then((res) => {
          console.log(res);
          this.$bvModal.msgBoxOk("Success!!");
        })
        .finally(() => {
          this.isBusy = false;
          this.$emit("detail-updated");
        });
    },
  },
};
</script>

<style scoped></style>
